import { createSlice } from "@reduxjs/toolkit";
import SingleJob from "../api/Jobs/index";
import { requests } from "api/index";
import URLS from "api/endPoints";

// Slice

const initiaJob = {
  CURRENTJOB: "",
  RELATEDJOBS: "",
  APPLICATIONSUMMARY: "",
};

const slice = createSlice({
  name: "SingleJob",
  initialState: {
    home: initiaJob,
  },
  reducers: {
    setSingleJob: (state, action) => {
      // console.log("KNOWPREVIEW REDUCER", action.payload)
      state.home.CURRENTJOB = action.payload;
    },
    setRelatedJob: (state, action) => {
      state.home.RELATEDJOBS = action.payload;
    },
    setapplicationSummary: (state, action) => {
      state.home.APPLICATIONSUMMARY = action.payload;
    },
  },
});

export default slice.reducer;

// Actions

const { setSingleJob, setRelatedJob, setapplicationSummary } = slice.actions;

export const getSingleJobAction = (payload) => async (dispatch) => {
  try {
    let response = await SingleJob.getSingleJob(payload);
    // console.log(response, "FROMAPI")
    if (response.ResponseCode == 100) {
      await dispatch(setSingleJob(response));
    }

    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getRelatedJobs = (payload) => async (dispatch) => {
  try {
    let response = await SingleJob.getrelatedJob(payload);
    // console.log(response, "FROMAPI")
    await dispatch(setRelatedJob(response.data));

    return await returnCode(response.data);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getapplicationSummary = (payload) => async (dispatch) => {
  try {
    let response = await SingleJob.applicationSummary(payload);
    // console.log(response, "FROMAPI")
    await dispatch(setapplicationSummary(response));

    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const jobApplyAction = (payload) => async (dispatch) => {
  try {
    let response = await SingleJob.jobApply(payload);
    // console.log(response, "FROMAPI")
    // await dispatch(setapplicationSummary(response))

    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const saveAppliedJobsHc = (payload) => async (dispatch) => {
  try {
    let response = await SingleJob.saveAppliedJobsHc(payload);
    // console.log(response, "FROMAPI")
    // await dispatch(setapplicationSummary(response))

    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

export const saveRegister = (payload) => async (dispatch) => {
  try {
    let response = await SingleJob.saveRegisterDetails(payload);
    // console.log(response, "FROMAPI")
    // await dispatch(setapplicationSummary(response))

    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};


function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
